class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


    /*document.getElementById('applyDiscount').addEventListener('click', function() {
      alert('test');
    var discountCode = document.getElementById('discountCode').value;
    window.location.href = '/discount/' + discountCode;
    });*/

function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + '; expires=' + expires.toUTCString() + '; path=/';
}
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1);
        if (c.indexOf(name) == 0)
            return c.substring(name.length, c.length);
    }
    return "";
}
  
  function discountCodeCartDrawer() {
    var discountCode = document.getElementById('discountCode').value;
    fetch(window.Shopify.routes.root + "discount/" + discountCode, {
      method: "GET"
    })
    .then((data) => {
       if(data){
         setCookie("discountCouponAdd", 0, 1);
         jQuery.post(window.Shopify.routes.root + 'cart/update.js', `note=${discountCode}`);
         document.getElementsByClassName("cart-discount")[0].style.display = "none";  
         document.getElementById("discountCodeID").innerHTML +=
            "<p>Added Coupon Code</p><h3>"+ discountCode +"</h3>";
                                          $.ajax({
                                          type: 'GET',
                                          url: '/cart.js',
                                          dataType: 'json',
                                          success: function(cartData) {
                                            var dis_ul_start = `<ul class="discounts list-unstyled" role="list" aria-label="Discount">`;
                                            var dis_html = ``;
                                            $.each(cartData.items, function(index, item) {
                                            console.log("Test data",item);
                                               $.each(item.discounts, function(index, discount) {
                                                 dis_html += `<li class="discounts__discount discounts__discount--end"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" viewBox="0 0 12 12">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                                                </path></svg>
                                                ${discount.title} (-$${discount.amount / 100})
                                                </li>` ;
                                                 });
                                                });
                                            var dis_ul_end = `</ul>`;
                                            $(".cart-drawer__footer .totals").next("div").html(dis_ul_start + dis_html + dis_ul_end);
                                                 console.log('hghghgs',dis_html);
                                                 console.log(dis_ul_start + dis_html + dis_ul_end);
                                          $(".totals__subtotal-value").text(`$${cartData.total_price / 100}`);
                                          },
                                          error: function(xhr, status, error) {
                                          console.error('Error fetching cart data:', status, error);  
                                          }
                                          });
       }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }



  var cartIconBubble = document.getElementById("cart-icon-bubble");
  cartIconBubble.addEventListener("click", (event) => {
    var cartSession = window.localStorage.getItem('__ui');
    var cartSessionSplt = cartSession.split("discountLines");   
    var cartSessionSplt2 = cartSessionSplt[1].split("metafields");
    document.getElementById("discountCodeID").innerHTML = '';
    fetch(window.Shopify.routes.root + "cart.js", { 
      method: 'GET'
    })
    .then(function(response) { return response.json(); })
    .then(function(json) {
      if(json?.note) {        
        var discountCouponAddCookie = getCookie('discountCouponAdd');
        if(discountCouponAddCookie != 1){
          document.getElementById("discountCodeID").innerHTML += "<p>Added Coupon Code</p><h3>"+ json.note +"</h3>";
          document.getElementsByClassName("cart-discount")[0].style.display = "none";          
        }
        
        if(cartSessionSplt2[0].search("title") >= 0){
          setCookie("discountCouponAdd", 1, 1);
           document.getElementById("discountCodeID").innerHTML = '';
           var cartSessionSpltSearch = cartSessionSplt2[0].search('"title":"'+json.note+'"');
            if(cartSessionSpltSearch >= 0){
              document.getElementById("discountCodeID").innerHTML += "<p>Added Coupon Code</p><h3>"+ json.note +"</h3>";
              document.getElementsByClassName("cart-discount")[0].style.display = "none"; 
            }else{
              document.getElementById("discountCodeID").innerHTML = '';
              document.getElementsByClassName("cart-discount")[0].style.display = "block"; 
            }
        }              
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });
